<template>
  <div
    class="case-overlay"
    @click="closeCase">
    <div class="case-container" @click.stop.prevent="nothing">
      <Close @close="closeCase" />
      <div class="case-content" v-if="loaded">
        <div class="case-cover">
          <MVMImage :width="c.cover.width" :height="c.cover.height" :img="c.cover" :sizeUrl="c.cover.sizes.lg" :date="new Date(c.updated_at).getTime()" />
        </div>
        <div class="case-name">
          {{ c.name }}
        </div>
        <div class="case-tags">
          <ul>
            <li
              v-for="(t, idx) in c.tags"
              :key="idx">
              {{ t }}
            </li>
          </ul>
        </div>
        <div class="case-description" v-html="c.html" />

        <!--
        <div class="case-actions">
          <button class="download">
            Download images
          </button>
          <button class="shop">
            Shop this
          </button>
        </div>
        -->

        <div class="case-images" v-if="c.image_series && c.image_series.images.length">
          <img
            v-for="i in c.image_series.images"
            :key="i.id"
            :src="`/media/${i.image.sizes.xlarge}`"
            class="img-fluid" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Close from './Close'
import MVMImage from './MVMImage'
import { TweenMax, Sine } from 'gsap'

TweenMax.defaultEase = Sine.easeOut

export default {
  name: 'MVMCase',
  components: {
    Close,
    MVMImage
  },

  props: {
    msg: String,
    slug: String
  },

  data () {
    return {
      lastScrollTop: 0,
      scrollDirection: 'down',
      $overlay: null,
      $close: null,
      closeBot: 0,
      closeTop: 0,
      closeHeight: 0,
      lastTrUp: 0,
      lastTrDown: 0,
      scrollChangePos: 0,
      topAuto: false,
      loaded: false,
      c: {
        meta_description: null,
        cover: {
          sizes: {
            lg: null
          }
        }
      },
      bgCol: '#000000'
    }
  },

  mounted () {
    axios
      .get(`/api/case/${this.slug}`)
      .then(response => {
        this.c = response.data.case
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loaded = true
        this.fadeIn()
      })

    this.$container = document.querySelector('.case-container')
    this.$close = document.querySelector('.close-icon-container')
    this.$overlay = document.querySelector('.case-overlay')
    this.$overlay.addEventListener('scroll', this.onScroll)
    let rect = this.$close.getBoundingClientRect()
    this.closeTop = rect.top
    this.closeBot = rect.bottom
    this.closeHeight = rect.bottom - rect.top
    document.querySelector('body').setAttribute('case-active', '')
    this.hideSticky()
  },

  destroyed () {
    console.log('=> destroyed')
    document.querySelector('body').removeAttribute('case-active')
    this.$overlay.removeEventListener('scroll', this.onScroll)
    this.removeActiveClasses()
    document.documentElement.style.overflowY = 'scroll'
    this.$overlay.style.overflowY = 'hidden'
    document.body.style.paddingRight = 0
  },

  inject: [
    'sbWidth'
  ],

  methods: {
    hideSticky () {
      let $sticky = document.querySelector('.contact-sticky')
      TweenMax.to($sticky, 0.25, {
        y: '-100',
        onComplete: () => {
          TweenMax.set($sticky, { display: 'none' })
        }
      })
    },

    removeActiveClasses () {
      let actives = document.querySelectorAll('.case.active')
      for (let a of actives) {
        a.classList.remove('active')
      }
      // actives.forEach(a => { a.classList.remove('active') })
    },

    isMobile () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },

    hideTagContainer (onCmp) {
      const tagContainer = document.querySelector('.tags-container')
      TweenMax.to(tagContainer, 0.2, {
        opacity: 0,
        onComplete: () => {
          TweenMax.set(tagContainer, {
            zIndex: 0
          })
          onCmp()
        }
      })
    },

    showTagContainer () {
      const tagContainer = document.querySelector('.tags-container')
      TweenMax.set(tagContainer, {
        zIndex: 5
      })
      TweenMax.to(tagContainer, 0.6, {
        opacity: 1
      })
    },

    hexToRgbA (hex, opacity) {
      let c
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
      }
      throw new Error('Bad Hex')
    },

    fadeIn () {
      let rgba
      let rgb = this.hexToRgbA(this.c.color, '1.0')

      if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) {
        rgba = this.hexToRgbA(this.c.color, '0.5')
      } else {
        rgba = this.hexToRgbA(this.c.color, '0.8')
      }

      TweenMax.set(this.$container, {
        y: 5,
        opacity: 0
      })

      TweenMax.set(this.$overlay, {
        opacity: 0,
        overflowY: 'hidden'
      })

      TweenMax.to(this.$overlay, 0.25, {
        backgroundColor: rgb,
        opacity: 1,
        onComplete: () => {
          document.documentElement.style.overflowY = 'hidden'
          this.$overlay.style.overflowY = 'auto'
          document.body.style.paddingRight = `${this.sbWidth}px`

          TweenMax.to(this.$container, 0.25, {
            opacity: 1,
            y: 0,
            onComplete: () => {
              TweenMax.to(this.$overlay, 0.25, {
                backgroundColor: rgba
              })
            }
          })
        }
      })
    },

    closeCase () {
      this.removeActiveClasses()
      TweenMax.to(this.$overlay, 0.25, {
        opacity: 1,
        backgroundColor: this.hexToRgbA(this.c.color),
        onComplete: () => {
          document.documentElement.style.overflowY = 'scroll'
          this.$overlay.style.overflowY = 'hidden'
          document.body.style.paddingRight = 0
          TweenMax.to(this.$container, 0.25, {
            opacity: 0,
            y: 5,
            onComplete: () => {
              TweenMax.to(this.$overlay, 0.25, {
                opacity: 0,
                onComplete: () => {
                  this.$router.push({ name: 'home' })
                }
              })
            }
          })
        }
      })
    },

    back () {
      alert('hepp!')
    },

    nothing () {

    },

    onScroll (e) {
      let scrollTop = e.target.scrollTop
      this.scrollDirection = (scrollTop < this.lastScrollTop) ? 'up' : 'down'
      this.lastScrollTop = scrollTop

      if (this.scrollDirection === 'up') {
        if (scrollTop > this.closeBot) {
          TweenMax.to(this.$close, 0.3, {
            y: '0',
            onComplete: () => {}
          })
        } else {
          // above the fold
          // TweenMax.set(this.$close, { top: 0, y: 0 })
          // this.topAuto = false
        }
      } else {
        if (scrollTop < this.closeBot) {
          // above the fold
          TweenMax.set(this.$close, { top: 'auto' })
          this.topAuto = true
        } else {
          if (this.topAuto) {
            TweenMax.set(this.$close, { top: 0, y: '-100' })
            this.topAuto = false
          } else {
            TweenMax.to(this.$close, 0.3, {
              y: '-100',
              onComplete: () => {}
            })
          }
        }
      }
    }
  }
}
</script>
